import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import {
  useAddBanMutation,
  useRemoveBanMutation,
  useBannedQuery,
} from "../Teams.state";
import { CardBody } from "../../App.styles";
import TeamOnlySelect from "../TeamOnlySelect";
import TeamSelect from "../TeamSelect";
import Spinner from "../../common/Spinner";

const Banned = () => {
  const { t } = useTranslation();
  const { addBan } = useAddBanMutation();
  const { removeBan } = useRemoveBanMutation();
  const { data: banned, isFetching } = useBannedQuery();

  const handleTeamBanChange = useCallback(
    async (selectedTeam) => {
      if (!selectedTeam) {
        return;
      }

      const players = selectedTeam.users || [];
      const allPlayersBanned = players.every((player) =>
        banned?.some((bannedPlayer) => bannedPlayer.id === player.id)
      );

      if (allPlayersBanned) {
        for (let player of players) {
          if (banned?.some((bannedPlayer) => bannedPlayer.id === player.id)) {
            await removeBan(player);
          }
        }
        return;
      }

      for (let player of players) {
        if (!banned?.some((bannedPlayer) => bannedPlayer.id === player.id)) {
          await addBan(player);
        }
      }
    },
    [addBan, banned, removeBan]
  );

  const handleBannedPlayersChange = useCallback(
    async (value) => {
      for (let player of (banned || []).filter(
        (bannedPlayer) => !(value || []).find((v) => v.id === bannedPlayer.id)
      )) {
        await removeBan(player);
      }
    },
    [banned, removeBan]
  );

  return (
    <CardBody className="card">
      <div className="card-header bg-dark text-light">
        <span className="card-title">{t("Banned")}</span>
      </div>
      <div className="card-body">
        <p
          dangerouslySetInnerHTML={{
            __html: t(
              "Anyone breaking the rules? Add them here to toss them from the game."
            ),
          }}
        />
        {isFetching && banned === undefined ? (
          <Spinner size="0.875rem" />
        ) : (
          <>
            <TeamOnlySelect
              setValue={handleTeamBanChange}
              mapLabel="name"
              placeholder={t("Select team...")}
              disableClearable={true}
              loading={isFetching}
            />
            <div className="mt-2">
              <TeamSelect
                setValue={handleBannedPlayersChange}
                value={banned}
                mapLabel="email"
                placeholder={t("Banned players")}
                loading={isFetching}
                readOnly
              />
            </div>
          </>
        )}
      </div>
    </CardBody>
  );
};

export default Banned;
